module.exports = "/lucky-balls/img/combos/28-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/28-.png
// module id = 1001
// module chunks = 0